// Application types

const THIRDPARTY = {
  LOADING: "LOADING",
  ALL_TIMEZONES: "ALL_TIMEZONES",
};

export default THIRDPARTY;
